import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { saveUserPreferences, getUserPreferences } from '../../services/userPreferences';
import { changeAppLanguage } from '../../i18n';

const Bar = styled.div`
  display: flex;
  justify-content: center;
  gap: 0.75rem;
  margin-bottom: 1.25rem;
  flex-wrap: wrap;
`;

const Select = styled.select`
  padding: 0.35rem 0.6rem;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.35);
  background: rgba(255, 255, 255, 0.12);
  color: white;
  font-size: 0.85rem;
  cursor: pointer;

  option {
    color: rgb(30, 30, 30);
  }
`;

export default function LoginPreferencesBar() {
  const { t, i18n } = useTranslation();
  const prefs = getUserPreferences();

  const onTheme = (e) => {
    saveUserPreferences({ theme: e.target.value }, { syncRemote: false });
  };

  const onLanguage = async (e) => {
    const language = e.target.value;
    saveUserPreferences({ language }, { syncRemote: false });
    await changeAppLanguage(language);
  };

  return (
    <Bar aria-label={t('appearance.title')}>
      <Select value={prefs.theme} onChange={onTheme} aria-label={t('appearance.theme')}>
        <option value="light">{t('theme.light')}</option>
        <option value="dark">{t('theme.dark')}</option>
        <option value="auto">{t('theme.auto')}</option>
      </Select>
      <Select
        value={i18n.language?.slice(0, 2) || prefs.language}
        onChange={onLanguage}
        aria-label={t('appearance.language')}
      >
        <option value="fr">{t('language.fr')}</option>
        <option value="en">{t('language.en')}</option>
        <option value="es">{t('language.es')}</option>
      </Select>
    </Bar>
  );
}
